import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';

const meGql = gql`
  query me {
    me {
      _id
      name
      phoneNumber
      condominiums {
        data
        role
        status
        permissions {
          vote
          comment
          view
        }
      }
    }
  }
`;

export default function useMe({ fetchPolicy = 'cache-first' } = {}) {
  const { data, refetch } = useQuery(meGql, {
    fetchPolicy,
  });

  const me = useMemo(() => {
    if (!data) return undefined;
    return data.me;
  }, [data]);

  return [me, refetch];
}
